
import HomePage from '../pages/home.f7.html';
import NotFoundPage from '../pages/404.f7.html';
import VerifyEmail from '../pages/verify_email.f7.html';
import Services from '../pages/services.f7.html';
import Me from '../pages/me.f7.html';
import Children from '../pages/children.f7.html';
import ICE from '../pages/ice.f7.html';
import ICE2 from '../pages/ice2.f7.html';
import QRCode from '../pages/qrcode.f7.html';
import Hesitates from '../pages/hesitates.f7.html';
import Hesitate from '../pages/hesitate.f7.html';
import MedicalRecords from '../pages/medical_records.f7.html';
import Privacy from '../pages/privacy.f7.html';
import CalendarList from '../pages/calendar_list.f7.html';
import CalendarItem from '../pages/calendar_item.f7.html';
import Notifications from '../pages/notifications.f7.html';
import Notification from '../pages/notification.f7.html';
import Documents from '../pages/documents.f7.html';
import Marketplace from '../pages/marketplace.f7.html';
import SetLanguage from '../pages/set_language.f7.html';

var routes = [
  {
    path: '/',
    component: HomePage,
  },
  {
    path: '/home/',
    component: HomePage,
  },
  {
    path: '/qrcode/',
    component: QRCode,
  },
  {
    path: '/notifications/',
    component: Notifications,
  },
  {
    path: '/notifications/:id/',
    component: Notification,
  },
  {
    path: '/marketplace/',
    component: Marketplace,
  },
  {
    path: '/documents/',
    component: Documents,
  },
  {
    path: '/calendar/',
    component: CalendarList,
  },
  {
    path: '/calendar/:id/',
    component: CalendarItem,
  },
  {
    path: '/hesitates/',
    component: Hesitates,
  },
  {
    path: '/hesitate/:id/',
    component: Hesitate,
  },
  {
    path: '/medical/',
    component: MedicalRecords,
  },
  {
    path: '/verify_email/',
    component: VerifyEmail,
  },
  {
    path: '/services/',
    component: Services,
  },
  {
    path: '/set_language/',
    component: SetLanguage,
  },
  {
    path: '/me/',
    async({resolve, reject}) {
      if(myApp.children) {
        resolve({component: Children});
      } else {
        resolve({component: Me});
      }
    }
  },
  {
    path: '/children/:children/',
    component: Children,
  },
  {
    path: '/ice/',
    component: ICE,
  },
  {
    path: '/ice2/',
    component: ICE2,
  },

  {
    path: '/privacy/',
    component: Privacy,
  },
  {
    path: '(.*)',
    component: NotFoundPage,
  },
];

export default routes;